var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.gridView)?_c('grid-view',{attrs:{"cases":_vm.caseFilter,"items":_vm.itemFilter,"type":_vm.type}}):_c('list-view',{attrs:{"cases":_vm.caseFilter,"items":_vm.itemFilter,"type":_vm.type}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04aeb7a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/content.vue
// module id = null
// module chunks = 